import { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';

// Contexts
import { withTranslate } from '../../core/TenantProvider';
// Components - Atoms, Organisms,Containers
import APButton from '../../components/atoms/APButton';
import APHeading from '../../components/atoms/APHeading';
import APLabel from '../../components/atoms/APLabel';
// Files in the same folder
import NotFound from './assets/404.svg';
import ErrorContainerStyles from './styles/ErrorContainer.style';
// Redux
import { ReducerState } from '../../redux/modules';

interface ErrorContainerProps extends WithStyles<typeof ErrorContainerStyles> {
  translate: Function,
  roleAccessFunction: any,
  variant: 'general' | 'keycloakAuthFail'
}

class ErrorContainer extends Component<ErrorContainerProps, {}> {
  render() {
    const {
      classes,
      translate,
      roleAccessFunction,
      variant = 'general'
    } = this.props;

    const { VIEW_ACCOUNT } = roleAccessFunction;
    const url = window.location.href;

    const isVariantAuthFail: boolean = url.indexOf("/keycloak_auth_fail") >= 0;

    return (
      <div className={classes.errorContainer}>
        <div className={classes.mainImage}>
          <img src={NotFound} alt="Not Found" />
        </div>
        <div className={classes.bodyContent}>
          <APHeading className={classes.errorHeader} variant="h4">
            {translate('errorcontainer.404.header')}
          </APHeading>
          <APLabel>
            {translate('errorcontainer.404.body')}
          </APLabel>
          {(variant !== 'keycloakAuthFail' && !isVariantAuthFail) &&
            <div className={classes.buttons}>
            {VIEW_ACCOUNT ? (<APButton color="primary" variant="contained" to="/account">
              {translate('errorcontainer.404.button.backtoaccount')}
            </APButton>) : <></>}
          </div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  roleAccessFunction: store.user.roleAccessFunction
});

export default withTranslate(
  withStyles(ErrorContainerStyles)(
    connect(mapStateToProps)(ErrorContainer)
  )
);
